import { Component, OnInit, Inject, Input, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { SimDataService } from '../../services/sim-data.service';
import {Observable, BehaviorSubject, merge, of, from, combineLatest, Subscription, defer} from 'rxjs';
import { SimWithUsage, Sim } from '../../models/sim';
import {switchMap, mergeMap, toArray, map, tap} from 'rxjs/operators';
import { Operator } from '../../models/operator';

@Component({
  selector: 'app-train-sims-usage',
  template: require('./train-sims-usage.component.html'),
  styles: [require('./train-sims-usage.component.sass')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainSimsUsageComponent implements OnInit, OnDestroy {

  @Input() projectId: number;
  @Input() trainId: number;

  dataSubscription: Subscription;

    sims: SimWithUsage[] | null;
    operators: Operator[];


    trainSims$: Observable<SimWithUsage[] | null>;
  private readonly refreshTrainSimsList$ = new BehaviorSubject(undefined);
  
  constructor(
    @Inject('TimeZoneFactory') private timeZoneFactory: any,
    private simDataService: SimDataService
  ) { 

      const operators$: Observable<Operator[]> = this.simDataService.getAllOperators(this.projectId);
      this.trainSims$ = combineLatest([this.refreshTrainSimsList$, operators$]).pipe(
      switchMap((result) => merge(
        of(null),
        this.simDataService.getSimsByTrain(this.projectId, this.trainId).pipe(
          map(sims => {
            const operators = result[1];
            return sims.map(sim => {
              const currentOperator: Operator | undefined = operators.find(operator => {
                return operator.code === String(sim.simConfig.operatorCode)
              });
              sim.simConfig.operator = currentOperator && currentOperator.network;
              return sim;
            })
          }),
          mergeMap((sims: Sim[]) => 
            // `from` emits each contact separately 
            from(sims).pipe(
              // load each contact
              mergeMap(
                sim => {
                const period = this.timeZoneFactory.formatUtcToBackendPeriod(sim.simConfig.currentBeginPeriod, sim.simConfig.currentEndPeriod);
                 return  this.simDataService.getSimUsage(
                  this.projectId,
                  sim.iccid,
                  period.start,
                  period.end
                )
              },
                // in result selector, connect fetched detail 
                (sim, simUsage) => ({
                  ...sim, 
                  ...simUsage
                })
              ),
              // collect all contacts into an array
              toArray()
            )
        ),
        )
    )))
  }

  ngOnInit(): void {
  }

  reload = () => {
    this.refreshTrainSimsList$.next(undefined);
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }

  }
}
